import PropTypes from 'prop-types';
import React from 'react';
import SpecCategory from './SpecCategory';

import '../global-sass/main.scss';

export default class DetailedSpecs extends React.Component {
	render() {
		const {
			specCategories,
			specification,
			widgetInfo,
			widgetHeading,
			toggleCollapse,
			panelHeadingWeight,
			panelHeadingCase
		} = this.props;

		if (specCategories.length === 0 || specification.length === 0) {
			return null;
		}

		return [
			specCategories.map(specCategory => {
				const { category = '', specIds = [] } = specCategory;
				if (category && specIds.length > 0) {
					return (
						<SpecCategory
							key={category}
							specCategory={category}
							specIds={specIds}
							specification={specification}
							widgetInfo={widgetInfo}
							widgetHeading={widgetHeading}
							toggleCollapse={toggleCollapse}
							panelHeadingWeight={panelHeadingWeight}
							panelHeadingCase={panelHeadingCase}
						/>
					);
				}
				return null;
			})
		];
	}
}

DetailedSpecs.propTypes = {
	specCategories: PropTypes.arrayOf(
		PropTypes.shape({
			category: PropTypes.string,
			specIds: PropTypes.array
		})
	),
	specification: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			spec: PropTypes.object.isRequired
		})
	),
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired
	}).isRequired,
	widgetHeading: PropTypes.string,
	toggleCollapse: PropTypes.string,
	panelHeadingWeight: PropTypes.string,
	panelHeadingCase: PropTypes.string
};

DetailedSpecs.defaultProps = {
	specCategories: [],
	specification: [],
	widgetHeading: '',
	toggleCollapse: '',
	panelHeadingWeight: 'font-weight-bold',
	panelHeadingCase: 'text-capitalize'
};



// WEBPACK FOOTER //
// ./src/components/DetailedSpecs.jsx